import { forwardRef } from 'react';
import type { Ref } from 'react';
import { windowUrlAdapter } from './infrastructure/browser/window-url-adapter';
import { StaticTableAdapter } from './infrastructure/static/static-adapter';
import type { TableApi, TableProps } from './domain';
import { IcsDataTable as BaseTable } from './ui/Table';

function WithUrlDefault<T>(
    props: TableProps<T>,
    ref: Ref<TableApi<T>>,
): JSX.Element {
    return (
        <BaseTable
            {...props}
            urlSync={props.urlSync ?? windowUrlAdapter}
            arrayAdapter={(rows) => new StaticTableAdapter(rows)}
            ref={ref}
        />
    );
}

export const IcsDataTable = forwardRef(WithUrlDefault) as <T>(
    props: TableProps<T> & { ref?: Ref<TableApi<T>> },
) => JSX.Element;
